export default "__VITE_ASSET__9jkI3qOd__"